import http from "../../http-common";

//LCoelho - OS: 17894 - ET: 03 - 29/04/2021 - Initial development

const getMenu = (data) => http.post("/Menu/GetMenu", data);

export default { getMenu };

//FIM - LCoelho - OS: 17894 - ET: 03 - 29/04/2021 - Initial development
